import { render, staticRenderFns } from "./FileAction.vue?vue&type=template&id=79ca016c"
import script from "./FileAction.vue?vue&type=script&lang=js"
export * from "./FileAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports